import React, { memo, useCallback, useState, useEffect, ReactElement } from "react";
import { Checkbox, CHECKBOX_ACCENT, AriaHidden } from "@swiggy-private/core-ui";
import { TIP_DETAIL_TEST_IDS } from "@swiggy-private/cart-test-ids";

import styles from "../styles/CartDeTip.scss";

export interface OptInProps {
    checked: boolean;
    onCheck?: (flag: boolean) => void;
    message: string;
}

const OPT_IN_CHK_BOX_NAME = "OPT_IN_CHK_BOX_NAME";

const Header = ({ checked, onCheck, message }: OptInProps): ReactElement => {
    const [_checked, setChecked] = useState(checked);

    useEffect(() => {
        setChecked(checked);
    }, [checked]);

    const chkOnChange = useCallback(() => {
        setChecked(!checked);
        if (typeof onCheck === "function") onCheck(!checked);
    }, [checked, onCheck]);
    return (
        <div
            role="checkbox"
            className={styles.optInContainer}
            tabIndex={0}
            onClick={chkOnChange}
            aria-checked={checked}
            data-testid={TIP_DETAIL_TEST_IDS.DE_TIP_OPT_IN_CHECKBOX}
        >
            <AriaHidden as="span">
                <Checkbox
                    checked={_checked}
                    name={OPT_IN_CHK_BOX_NAME}
                    value={OPT_IN_CHK_BOX_NAME}
                    accent={CHECKBOX_ACCENT.SWIGGY_ORANGE}
                />
            </AriaHidden>
            <p className={styles.optInMessage}>{message}</p>
        </div>
    );
};

export default memo(Header);
